export function raiseErrorMessage(messageParam) {
  var message = messageParam || 'Something went wrong with your request.';
  if (!hasToastrSetup(window)) {
    console.error('no toastr available to deliver error message:', message);
    return;
  }
  //@ts-expect-error TODO: fix this
  window.toastr.error(message);
}
function hasToastrSetup(win) {
  var _win$toastr;
  return typeof ((_win$toastr = win.toastr) === null || _win$toastr === void 0 ? void 0 : _win$toastr.error) === 'function';
}